// Define all valid roles in one place
const userRoles = ["landlord", "managersManager"] as const;
export type UserRole = (typeof userRoles)[number];

/**
 * Checks if the provided role exists in the predefined userRoles array.
 * @param role - Role name to check (e.g. "landlord", "managersmanager").
 * @returns boolean - true if role exists, false otherwise.
 */
export const checkUserRole = (role: string): boolean => {
  return userRoles.includes(role as UserRole);
};
